import { runDemo } from "../shared/demoRunner";
import { createCsgScene } from "./scene";

runDemo({ createScene: createCsgScene });
